<template>
  <div class="resource_data_schema">
    <div class="form-row">
      <div class="form-group col-12">
        <label>
          {{ $t('resource.dataSchema.identifier') }}
        </label>
        <ValidationProvider
          v-slot="{ classes, errors }"
          ref="dataSchema-identifier"
          :rules="resource.schemaVersion || resource.schemaFormat ? 'required' : ''"
          :name="`Identifiant schéma de données ressource`"
        >
          <div
            class="control"
            :class="classes"
          >
            <input
              v-model="resource.schemaIdentifier"
              v-sanitize
              class="form-control"
              type="text"
              @change="ressourceChanged()"
              :placeholder="$t('resource.dataSchema.identifier')"
            >
            <span class="form-errors">{{ errors[0] }}</span>
          </div>
        </ValidationProvider>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-12">
        <label>
          {{ $t('resource.dataSchema.version') }}
        </label>
        <ValidationProvider
          v-slot="{ classes, errors }"
          ref="dataSchema-version"
          :rules="resource.schemaIdentifier || resource.schemaFormat ? 'required' : ''"
          :name="`Version schéma de données ressource`"
        >
          <div
            class="control"
            :class="classes"
          >
            <input
              v-model="resource.schemaVersion"
              v-sanitize
              class="form-control"
              type="text"
              @change="ressourceChanged()"
              :placeholder="$t('resource.dataSchema.version')"
            >
            <span class="form-errors">{{ errors[0] }}</span>
          </div>
        </ValidationProvider>
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-12">
        <label>
          {{ $t('resource.dataSchema.format') }}
        </label>
        <ValidationProvider
          v-slot="{ classes, errors }"
          ref="dataSchema-format"
          :rules="resource.schemaIdentifier || resource.schemaVersion ? 'required' : ''"
          :name="`Format schéma de données ressource`"
        >
          <div
            class="control"
            :class="classes"
          >
            <input
              v-model="resource.schemaFormat"
              v-sanitize
              class="form-control"
              type="text"
              @change="ressourceChanged()"
              :placeholder="$t('resource.dataSchema.format')"
            >
            <span class="form-errors">{{ errors[0] }}</span>
          </div>
        </ValidationProvider>
      </div>
    </div>
    <div
      class="alert alert-light d-flex align-items-center mb-0"
      style="font-size: 0.9rem;"
      role="alert"
    >
      <i
        class="bi bi-info-circle-fill"
        style="margin-right: 1em;"
      />
      <a
        href="https://schema.data.gouv.fr/"
        target="blank"
        class="alert-link"
      >
        {{ $t('resource.dataSchema.infoLink') }}
      </a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { ValidationProvider, extend, configure } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import datasetAPI from '../../../../api/modules/dataset.api';
extend('required', {
  ...required,
  message: 'Ce champ est requis'
});
configure({
  classes: {
    valid: 'is-valid',
    invalid: 'is-invalid'
  }
});

export default {
  name: 'ResourceDataSchema',

  components: {
    ValidationProvider
  },
  
  props: {
    resource: {
      type: Object,
      default: () => {}
    },
    

  },
  computed: {
    ...mapState('datasets', [
      'currentDataset',
    ]),
  },
  methods: {

    ressourceChanged(){
      this.resource.dirty=true;
      /*if(this.resource.id){
        datasetAPI.updateDatasetResource(this.currentDataset.id, this.resource,false)
          .then(() => {
              
          })
          .catch((err) => {
            console.error(err);
          });
      }*/
    },
  }
};
</script>
